/**
 * @import { Feature, LineString } from 'geojson'
 */

import { degreesPerPixel } from '@/utils/map';
import { useMemo } from 'react';

/**
 * @param {Feature<LineString>} feature
 * @param {number} zoom
 * @param {number} [minLineLengthPixels]
 */
export function useShowArrow(zoom, feature, minLineLengthPixels = 120) {
  return useMemo(() => {
    const dpp = degreesPerPixel(Math.max(0, zoom));
    const coordinates = feature.geometry.coordinates;
    let totalDistancePixels = 0;
    for (let i = 1, length = coordinates.length; i < length && totalDistancePixels < minLineLengthPixels; i++) {
      totalDistancePixels +=
        Math.sqrt(
          Math.pow(coordinates[i][0] - coordinates[i - 1][0], 2) +
            Math.pow(coordinates[i][1] - coordinates[i - 1][1], 2)
        ) / dpp;
    }
    return totalDistancePixels >= minLineLengthPixels;
  }, [zoom, feature, minLineLengthPixels]);
}
